/* Page Template - Portal Form
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "../../../sass/layouts/page_templates/template-page-portal-form.scss";

// Add the "required" asterisk to certain PM Pro form inputs.
const firstName = document.querySelector('[for="first_name"]');
const lastName = document.querySelector('[for="last_name"]');
if (firstName && lastName) {
    [firstName, lastName].forEach(name => {
        name.textContent = name.textContent + '*';
    });
}

// Remove the `size` attribute from inputs to allow proper Flexbox control.
const inputs = document.querySelectorAll('.pmpro_checkout input');
inputs.forEach(input => {
    input.removeAttribute('size');
});

// Watch form checkboxes to allow checkmark handling.
const ndaCheckbox = document.getElementById('nda_agreement');
const rememberCheckbox = document.getElementById('rememberme');
if (ndaCheckbox) {
    ndaCheckbox.addEventListener('change', event => updateCheckboxClasses(event));
}
if (rememberCheckbox) {
    rememberCheckbox.addEventListener('change', event => updateCheckboxClasses(event));
}

const updateCheckboxClasses = event => {
    if (event.currentTarget.checked) {
        event.currentTarget.classList.add('rs-portal-form__checkbox-checked');
    } else {
        event.currentTarget.classList.remove('rs-portal-form__checkbox-checked');
    }
};

// Arrange login form HTML for checkmark handling.
const rememberLabel = document.querySelector('.login-remember label');
if (rememberLabel) {
    rememberLabel.parentNode.insertBefore(rememberCheckbox, rememberLabel);
    rememberLabel.setAttribute('for', 'rememberme');
}

// Remove the originally-generated submit button that's been replaced with our own.
// It could not be filtered out, so we're removing it in the client.
const submitButton = document.querySelector('.pmpro_login_wrap .login-submit');
if (submitButton) {
    submitButton.remove();
}

// Replace the "Lost password?" link with instructions.
// There are no filters to do this on the back-end.
const lostPasswordLink = document.querySelector('.rs-page-portal-form__form .pmpro_error a');
if (lostPasswordLink && lostPasswordLink.textContent === 'Lost your password?') {
    lostPasswordLink.outerHTML = 'Please reach out to <a href="mailto:hello@vecnarobotics.com">hello@vecnarobotics.com</a> if you want to reset it.';
}
